/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Mary_Ballard_JohanssonInputs */

const en_testimonial_mary_ballard_johansson = /** @type {(inputs: Testimonial_Mary_Ballard_JohanssonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What a great app! The reading voice is pleasant and understandable, even on the harder words. Having the text available to read along helps also. Naturally, as with any new app, there are bugs. But support is readily available. Highly recommend this for anyone doing research or just keeping up with the latest articles.`)
};

const es_testimonial_mary_ballard_johansson = /** @type {(inputs: Testimonial_Mary_Ballard_JohanssonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Qué gran app! La voz de lectura es agradable y comprensible, incluso en las palabras más difíciles. Tener el texto disponible para leer junto ayuda también. Naturalmente, como con cualquier app nueva, hay errores. Pero el soporte está disponible. Muy recomendable para cualquiera que investigue o simplemente se mantenga al día con los últimos artículos.`)
};

/**
* | output |
* | --- |
* | "What a great app! The reading voice is pleasant and understandable, even on the harder words. Having the text available to read along helps also. Naturally, ..." |
*
* @param {Testimonial_Mary_Ballard_JohanssonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_mary_ballard_johansson = /** @type {((inputs?: Testimonial_Mary_Ballard_JohanssonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Mary_Ballard_JohanssonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_mary_ballard_johansson(inputs)
	return en_testimonial_mary_ballard_johansson(inputs)
});